import React, { useEffect } from "react";
import "./BlogDetail3.css";
import { FaFacebookF,  FaInstagram, FaLinkedinIn,  } from "react-icons/fa";
import blogBg from "../../assets/images/data3.jpg"; // final bg for info section
import extraImg from "../../assets/images/data3.jpg"; // enquiry left image

const BlogDetail3 = () => {
  // ========= UPDATED SCROLL ANIMATION FUNCTIONALITY (REPEATABLE) ==========
  useEffect(() => {
    // Define the custom animation classes to observe
    // This list ensures all new animated elements are targeted.
    const classesToObserve = [
      ".slide-in-left-fast",
      ".slide-in-top-smooth",
      ".slide-in-right-subtle",
      ".slide-in-left",
    ];

    const elements = document.querySelectorAll(classesToObserve.join(", "));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            // Remove 'active' when out of view to re-trigger the animation (repeatable animation)
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 } // Animation starts when 20% of element is visible
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []); // Run once on mount

  return (
    <>
      {/* ============================================ HERO SECTION ========================================================= */}
      {/* Removed scroll-reveal class from section, only applying animation to overlay */}
      <section
        className="blog-hero-section"
        style={{ backgroundImage: `url(${blogBg})` }}
      >
        {/* HERO OVERLAY: Left से fast स्लाइड-इन (slide-in-left-fast) */}
        <div className="blog-hero-overlay slide-in-left-fast">
          <span className="blog-category">Blog, Business, Marketing</span>

          <h1 className="blog-title">
          Unlocking Business Potential: How NMD Infotech Services Can Propel Your Growth
          </h1>

          <div className="blog-meta">
            <p>
              <i className="fa-solid fa-calendar"></i> December 12, 2024
            </p>
            <p>
              <i className="fa-solid fa-comments"></i> No Comments
            </p>
          </div>
        </div>
      </section>

      {/* =============================================== ENQUIRY + NEWSLETTER SECTION======================================== ================= */}
      {/* ENQUIRY SECTION: ऊपर से smooth scroll (slide-in-top-smooth) */}
      <section className="enquiry-section slide-in-top-smooth">
        {/* LEFT IMAGE */}
        <div
          className="enquiry-left"
          style={{ backgroundImage: `url(${extraImg})` }}
        />

        {/* RIGHT FORM */}
        <div className="enquiry-right">
          <h2 className="enquiry-title">Newsletter</h2>
          <p className="enquiry-text">
            Get free tips and resources right in your inbox, along with 10,000+
            others
          </p>

          <form className="enquiry-form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <button type="submit">Sign Up</button>
          </form>
        </div>
      </section>

      {/* ================================================ INFO SECTION================================================ ================= */}
      {/* Removed scroll-reveal class from section, only applying animation to content */}
      <section
        className="info-section"
        style={{ backgroundImage: `url(${blogBg})` }}
      >
        <div className="info-overlay"></div>
        {/* INFO CONTENT: Right से हल्का स्लाइड-इन (slide-in-right-subtle) */}
        <div className="info-content slide-in-right-subtle">
          <h2 className="info-heading">Empowering Data-Driven Decisions</h2>

       
          <p>
          In today’s fast-paced digital world, businesses must adapt to ever-changing technologies and strategies to stay competitive. Whether you are a budding startup or a well-established enterprise, harnessing the power of digital solutions is essential for sustained growth. NMD Infotech is your ultimate partner in navigating this dynamic landscape. With a comprehensive suite of services—digital marketing, website and app development, data analysis, IT consulting, and business development consulting—NMD Infotech provides everything you need to elevate your business to new heights. Let’s delve into how our services can transform your business and unlock its full potential.
          </p>
        </div>
      </section>


      {/* ============================================ LATEST POSTS SECTION =============================================================== */}
      {/* LATEST POSTS: Left से स्लाइड-इन (slide-in-left) */}
      <section className="latest-posts-section slide-in-left">
        <div className="latest-posts-container">
          <div className="posts-list">
            <h2 className="posts-heading">Latest Posts</h2>

            {/* Post 1 */}
            <div className="post-item">
              <img src={require("../../assets/images/post1.png")} alt="Data Science" />
              <div className="post-info">
                <h3>Data Science</h3>
                <p>From Numbers to Knowledge: The Art of Data Science</p>
                <span>16 December 2024</span>
              </div>
            </div>

            {/* Post 2 */}
            <div className="post-item">
              <img src={require("../../assets/images/post2.png")} alt="Empower Your Business" />
              <div className="post-info">
                <h3>Empower Your Business with NMD Infotech’s Data Analytics Services</h3>
                <span>16 December 2024</span>
              </div>
            </div>

            {/* Post 3 */}
            <div className="post-item">
              <img src={require("../../assets/images/post3.png")} alt="NMD Infotech Services" />
              <div className="post-info">
                <h3>NMD Infotech Services</h3>
                <p>Unlocking Business Potential: How NMD Infotech Services Can Propel Your Growth</p>
                <span>12 December 2024</span>
              </div>
            </div>

            {/* Post 4 */}
            <div className="post-item">
              <img src={require("../../assets/images/post4.png")} alt="Digital Marketing vs Traditional Marketing" />
              <div className="post-info">
                <h3>Digital Marketing vs Traditional Marketing</h3>
                <span>31 March 2024</span>
              </div>
            </div>

            {/* Post 5 */}
            <div className="post-item">
              <img src={require("../../assets/images/post5.png")} alt="Tips for Digital Marketing" />
              <div className="post-info">
                <h3>Tips for Digital Marketing</h3>
                <span>27 March 2024</span>
              </div>
            </div>

            {/* Post 6 */}
            <div className="post-item">
              <img src={require("../../assets/images/post6.png")} alt="Tip’s Of Digital Marketing For Small Business" />
              <div className="post-info">
                <h3>Tip’s Of Digital Marketing For Small Business</h3>
                <span>March 2014</span>
              </div>
            </div>
          </div>

          <div className="posts-image">
            <img src={require("../../assets/images/data3.jpg")} alt="Blog Highlight" />
          </div>
        </div>
      </section>




      {/* ============================================== DATA SCIENCE FULL CONTENT SECTION =========================================================================== */}
    
  
     {/* ===================================== OUR PROFESSIONAL SERVICES + ANIMATION ===================================== */}
<section className="nmd-services-section slide-in-top-smooth">

<h2 className="nmd-title slide-in-left-fast">Our Professional Services</h2>

<p className="nmd-subtitle slide-in-right-subtle">
  Empowering your business with modern technology, innovation & strategy.
</p>

<div className="nmd-services-grid">

  {/* 1. Digital Marketing */}
  <div className="nmd-card slide-in-left">
    <h3>Digital Marketing</h3>
    <p>
      Amplify your online presence with SEO, PPC, social media, email campaigns
      and content marketing tailored to your brand.
    </p>
    <ul>
      <li>SEO to boost rankings</li>
      <li>Social Media Management</li>
      <li>Content Marketing</li>
      <li>Data-driven strategies</li>
    </ul>
  </div>

  {/* 2. Website Development */}
  <div className="nmd-card slide-in-right-subtle">
    <h3>Website Development</h3>
    <p>
      We design stunning, responsive and conversion-focused websites built with
      SEO best practices.
    </p>
    <ul>
      <li>Responsive Design</li>
      <li>E-commerce Solutions</li>
      <li>SEO Optimization</li>
    </ul>
  </div>

  {/* 3. App Development */}
  <div className="nmd-card slide-in-left-fast">
    <h3>App Development</h3>
    <p>
      High-performing Android, iOS and cross-platform apps with user-centric
      designs.
    </p>
    <ul>
      <li>Android / iOS / Cross-Platform</li>
      <li>User-centric UI/UX</li>
      <li>Maintenance & Support</li>
    </ul>
  </div>

  {/* 4. Data Analysis */}
  <div className="nmd-card slide-in-right-subtle">
    <h3>Data Analysis</h3>
    <p>
      Unlock actionable insights with customer analytics, performance tracking
      and predictive forecasting.
    </p>
    <ul>
      <li>Customer Insights</li>
      <li>Performance Metrics</li>
      <li>Predictive Analytics</li>
    </ul>
  </div>

  {/* 5. IT Consulting */}
  <div className="nmd-card slide-in-left">
    <h3>IT Consulting</h3>
    <p>
      Modern IT solutions to streamline your business operations, enhance
      security and improve efficiency.
    </p>
    <ul>
      <li>Infrastructure Assessment</li>
      <li>Cloud Solutions</li>
      <li>Cybersecurity</li>
    </ul>
  </div>

  {/* 6. Business Development */}
  <div className="nmd-card slide-in-right-subtle">
    <h3>Business Development & Consulting</h3>
    <p>
      Strategic planning, market research and process optimization for
      sustainable growth.
    </p>
    <ul>
      <li>Market Research</li>
      <li>Strategic Planning</li>
      <li>Process Optimization</li>
    </ul>
  </div>

</div>
</section>


       
      {/* POST COMMENT SECTION: ऊपर से smooth scroll (slide-in-top-smooth) */}
<section className="share-comment-section slide-in-top-smooth">

{/* SHARE BOX */}
<div className="share-box">
  <h3>Share it:</h3>

  <div className="share-icons">
  <a href="https://www.facebook.com/digitalmarketingnmd?mibextid=2JQ9oc" className="icon fb"><FaFacebookF /></a>
            <a href="https://www.instagram.com/nmdinfotech/?igsh=M2lnM205YXZ6b3lp#" className="icon tw"><FaInstagram /></a>
            <a href="https://in.linkedin.com/company/nmd-infotech" className="icon ln"><FaLinkedinIn /></a>
  </div>
</div>

{/* COMMENT FORM — Web3Forms Access Key */}
<div className="glass-form">
  <h2>Leave a Reply</h2>
  <p>Your email address will not be published. Required fields are marked *</p>

  <form
    action="https://api.web3forms.com/submit"
    method="POST"
    className="webform3"
  >
    {/* REQUIRED ACCESS KEY */}
    <input type="hidden" name="access_key" value="YOUR_ACCESS_KEY_HERE" />

    {/* Auto Subject */}
    <input type="hidden" name="subject" value="New Blog Comment Submitted" />

    {/* Comment */}
    <label>Comment *</label>
    <textarea name="comment" placeholder="Write your comment..." required></textarea>

    {/* Name */}
    <label>Name *</label>
    <input type="text" name="name" placeholder="Enter your name" required />

    {/* Email */}
    <label>Email *</label>
    <input type="email" name="email" placeholder="Enter your email" required />

    {/* Website */}
    <label>Website</label>
    <input type="text" name="website" placeholder="Your website (optional)" />

    <div className="checkbox-row">
      <input type="checkbox" />
      <span>Save my info for next time.</span>
    </div>

    <button className="submit-btn">Post Comment</button>
  </form>
</div>

</section>
    </>
  );
};

export default BlogDetail3;